export default {
  offset: {
    top: 30,
    right: 30,
    bottom: 30,
    left: 30,
  },
  label: {
    enable: true,
    styles: {
      fontSize: 14,
      color: '#fff',
    },
  },
  value: {
    enable: true,
    styles: {
      fontSize: 14,
      color: '#fff',
    },
  },
  area: {
    gradient: false,
    smooth: true
  },
  hover: {
    enable: true,
    value: 15
  }
};
